import React from 'react';

export const useIsLandscape = () => {
	const [isLandscape, setIsLandscape] = React.useState(() => window.matchMedia('(orientation: landscape)').matches);
	React.useEffect(() => {
		const mq = window.matchMedia('(orientation: landscape)');
		const handler = (e: MediaQueryListEvent) => setIsLandscape(e.matches);
		mq.addEventListener('change', handler);
		return () => mq.removeEventListener('change', handler);
	}, []);
	return isLandscape;
};
